// 🚀 Pages publiques chargées à la demande (routes/index.js). preloadPage : le morceau de code de
// la page demandée est téléchargé dès le démarrage du site (index.js), pendant l'écran de
// chargement d'App.js, au lieu d'après. Même fonction que React.lazy : webpack le télécharge une
// fois et la page le trouve prêt. Avant, sur téléphone en 4G, la recherche attendait près d'une
// seconde de plus ses morceaux, demandés seulement après l'écran de chargement.
export const PAGE_LOADERS = {
  "/": () => import("../HomeTwo"),
  "/searchTeacher": () => import("../components/SearchTeacher"),
  "/Teacher-Details": () => import("../pages/searchTeacher/TeacherDetails"),
  "/becomeTeacher": () => import("../pages/becomeTeacher/BecomeTeacher"),
  "/onlineCourses": () => import("../pages/onlineCourses/OnlineCourses"),
  "/whoAreWe": () => import("../pages/whoAreWe/AboutUs"),
  "/MyLevel": () => import("../pages/myLevel/MyLevel"),
  "/helpcenter": () => import("../pages/helpCenter/HelpCenter"),
  "/contact": () => import("../pages/contact/Contact"),
  "/termsCondition": () => import("../pages/termsCondition/TermsCondition"),
  "/privacyPolicy": () => import("../pages/privacyPolicy/PrivacyPolicy"),
  "/legalNotice": () => import("../pages/legalNotice/LegalNotice"),
  "/login": () => import("../pages/account/Login"),
};

// 🎨 Pages du nouveau design (tour 50) : demandées en même temps que le module qui choisit le design.
// Avant, ce module arrivait, puis seulement il demandait la page du nouveau design, un aller-retour de
// plus avant le premier affichage. Le nouveau design est allumé pour tous depuis le 29 octobre : s'il
// est coupé, ce morceau est téléchargé pour rien, sans autre effet.
export const ND_PAGE_LOADERS = {
  "/": () => import("../components/nouveauDesign/accueil/HomeNd"),
  "/searchTeacher": () => import("../components/nouveauDesign/recherche/SearchNd"),
  "/Teacher-Details": () => import("../components/nouveauDesign/fiche/FicheNd"),
};

// Accueil préchargé lui aussi depuis le tour 50. Avant, jamais : avec l'ancien accueil, son plus grand
// élément (titre et image de la bannière) arrivait 0,27 s plus tard, l'image partageant la bande
// passante avec le code (tour 25). Le nouvel accueil n'a pas d'image en haut. Recherche : 4,69 s →
// 3,77 s sans contrepartie (tour 25).
export const NOT_PRELOADED = new Set();

// Rien pour une page qui n'est pas dans la liste. Une erreur (réseau) n'est pas affichée : la page
// redemande son morceau à l'affichage, comme avant
// 🔗 Adresse lisible de la fiche (/prof/…, tour 60) : la même page que /Teacher-Details
export const preloadPage = (path, loaders = PAGE_LOADERS, ndLoaders = ND_PAGE_LOADERS) => {
  const pathname = /^\/prof\/./.test(path || "") ? "/Teacher-Details" : path;
  if (NOT_PRELOADED.has(pathname)) return;
  for (const load of [loaders[pathname], ndLoaders[pathname]]) if (load) load().catch(() => {});
};
